export class ModulesLoader {
  constructor(modules) {
    this.dataModules = Array.prototype.slice.call(modules);
  }

  loadModules(domSource) {
    const modulesInfo = [];
    this.dataModules.forEach((module) => {
      modulesInfo.push(this.loadModule(module, domSource));
    });
    if (process.env.NODE_ENV !== "production") {
      this.showModulesInfo(modulesInfo);
    }
  }

  loadModule(module, domSource = document) {
    if (!module.domTarget)
      module.domTarget = `[data-module="${module.className}"]`;
    if (!module.domElements) module.domElements = [];
    const newElements = [];
    const elements = Array.prototype.slice.call(
      domSource.querySelectorAll(module.domTarget)
    );
    elements.forEach((element) => {
      if (!this.containsDomElement(element, module.domElements)) {
        module.domElements.push(element);
        new module.classModule(element);
        newElements.push(element);
      }
    });
    return { module: module, elements: elements, newElements: newElements };
  }

  showModulesInfo(modulesInfo) {
    console.groupCollapsed(
      "%c Modules loaded ",
      "color: #d9d9d9; background-color: #0693e3"
    );
    modulesInfo.forEach((moduleInfo) => {
      const module = moduleInfo.module;
      console.groupCollapsed(
        `${module.domElements.length} ${module.className}(s) loaded (${moduleInfo.newElements.length} new)`
      );
      console.info(module);
      console.groupEnd();
    });
    console.groupEnd();
  }

  containsDomElement(domElement, domArray) {
    for (const arrayElement of domArray) {
      if (arrayElement.isSameNode(domElement)) {
        return true;
      }
    }
    return false;
  }
}
